export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/wine.072527f6.svg","height":175,"width":175,"blurWidth":0,"blurHeight":0};